<template>
    <div class="card">
        <div class="card-header">
            <div class="d-flex align-items-center justify-content-between">
                <div>表示中のメニュー</div>
                <b-button
                    @click="toggle"
                    size="sm"
                    variant="yokumiru-gray"
                    :class="{ 'd-none' : isShow }">開く
                </b-button>
                <b-button
                    @click="toggle"
                    size="sm"
                    variant="yokumiru-gray"
                    :class="{ 'd-none' : ! isShow }">
                    閉じる
                </b-button>
            </div>
        </div>
        <div
            class="card-body doctorDoctorMenu pt-2"
            :class="{ 'd-none' : ! isShow }">
            <template v-for="menu in doctorMenus">
                <doctor-doctor-menu :menu="menu"/>
            </template>
        </div>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'

    export default {
        props: {
            doctorMenus: {
                type: Array,
                required: true,
            },
        },

        data: function () {
            return {
                isShow: true
            }
        },

        created: function () {
            this.isShow = this.$store.state.doctorMode.isShowDoctorMenu
        },

        methods: {
            toggle: function () {
                this.isShow = !this.isShow
                this.toggleIsShowDoctorMenu()
            },

            ...mapMutations({
                toggleIsShowDoctorMenu: 'doctorMode/toggleIsShowDoctorMenu',
            }),
        },
    }
</script>

<style lang="scss" scoped>
.card-body {
    max-height: 550px;
    overflow-x: auto;
}

.doctorDoctorMenu {
    .doctorMenu {
        margin: 15px;
    }
}
</style>
